import React, { useContext, useEffect,useState } from "react";
import ParameterContext from "../../context/parameter/parameterContext";
import TradathonContext from "../../context/tradathon/TradathonContext";
import LiveCard from "../../components/LiveCard";
import CompletedCard from "../../components/CompletedCard";
import DummyLiveCard from "../../components/DummyLiveCard";
const Tradathon = ({ history }) => {
  const {
    setTradathonListingTab,
    listingTab,
    setColumnName,
  } = useContext(ParameterContext);
  const {
    getContests,
    contests,
    setActiveRoom,
    clearRoomData,
    tradathonLoading,
    tradathon_setTotalInvAmount,
    tradathon_setTotalCurrentAmount,
    tradathon_setTotalNetPL,
    setUserJoined,
    clearContests,
    publicContests,
  } = useContext(TradathonContext);
  // const [upcomingListingTab, setUpcomingListingTab] = useState("publicLive");

  const [activeModalId, setActiveModalId] = useState(null);
  useEffect(() => {
    clearContests();

    if (listingTab === "live") {
      getContests("live");
    }
    if (listingTab === "past") {
      getContests(2);
    }
    if (listingTab === "upcoming") {
      setUserJoined()
      // if (upcomingListingTab === "publicLive") {
      //   getContests(1, "public");
      // } else

      // if (upcomingListingTab === "publicUpcoming") {
      getContests(0, "public");
      // }
    }

    //eslint-disable-next-line
  }, [listingTab]);
  useEffect(() => {
    setColumnName(null);
    clearRoomData();
    tradathon_setTotalInvAmount(0);
    tradathon_setTotalCurrentAmount(0);
    tradathon_setTotalNetPL(0);
    //eslint-disable-next-line
  }, []);
  return (
    <div className="Tradathon">
      <div className="Tradathon__container">
        <div className="Tradathon__listings">
          <div className="Favourite__tabs">
            <button
              className={
                listingTab === "upcoming"
                  ? "Favourite__exchange-tab"
                  : "Favourite__portfolio-tab"
              }
              onClick={() => setTradathonListingTab("upcoming")}
            >
              Contests
            </button>
            <button
              className={
                listingTab === "live"
                  ? "Favourite__exchange-tab"
                  : "Favourite__portfolio-tab"
              }
              onClick={() => setTradathonListingTab("live")}
            >
              My Contests
            </button>
            <button
              className={
                listingTab === "past"
                  ? "Favourite__exchange-tab"
                  : "Favourite__portfolio-tab"
              }
              onClick={() => setTradathonListingTab("past")}
            >
              Completed
            </button>
          </div>
        </div>
        <div style={{ minHeight: listingTab === "upcoming" ? "100vh" : 0 }}>
          {listingTab === "upcoming" ? (
            <>
              <div
                className="Tradathon__listings__upcoming__lists"
                // style={{ position: "sticky", top: 0 }}
              >
                <div className="Tradathon__listings__upcoming__lists__content">
                  <h2>
                    Private Room
                    <span>(Invite , Analyse , Build , Earn)</span>
                  </h2>
                  <p>
                    Invite your friends to join your own custom room , fix your
                    entry amount, build your portfolios with virtual money, and
                    let's the game begin. Crypto world is gonna be a great fun
                    competing with other fellow investors.
                  </p>
                </div>
                <button
                  className="TradathonRoom__join__button"
                  style={{
                    background: "rgba(69, 170, 67, 1)",
                    borderRadius: "5px",
                    whiteSpace: "nowrap",
                  }}
                  onClick={() => history.push("/tradathon/room")}
                >
                  CREATE NOW
                </button>
              </div>
              {/* 
              <div className="Tradathon__listings">
                <div className="Favourite__tabs">
                  <button
                    className={
                      upcomingListingTab === "publicLive"
                        ? "Favourite__exchange-tab"
                        : "Favourite__portfolio-tab"
                    }
                    onClick={() => setUpcomingListingTab("publicLive")}
                  >
                    Live
                  </button>
                  <button
                    className={
                      upcomingListingTab === "publicUpcoming"
                        ? "Favourite__exchange-tab"
                        : "Favourite__portfolio-tab"
                    }
                    onClick={() => setUpcomingListingTab("publicUpcoming")}
                  >
                    Upcoming
                  </button>
                </div>
              </div> */}

              <div>
                {tradathonLoading ? (
                  [...Array(10).keys()].map((c, index) => (
                    <div style={{ marginBottom: "10px" }} key={index}>
                      <DummyLiveCard key={index} />
                    </div>
                  ))
                ) : publicContests && publicContests.data?.length > 0 ? (
                  publicContests.data.map((d, index) => (
                    <div
                      style={{ marginBottom: "10px" }}
                      key={d._id}
                      onClick={() =>{setActiveModalId(d._id)
                      setUserJoined()}}
                    >
                      <LiveCard
                        key={d._id}
                        noOfPlayers={d.noOfPlayers}
                        startTime={d.startTime}
                        endTime={d.endTime}
                        entryFees={d.entryFees}
                        prize={d.prize}
                        rtype={d.rtype}
                        joinedMembers={d.joinedMembers}
                        rname={d.rname}
                        isFlexible={d.isFlexible}
                        rstatus={d.rstatus}
                        rcode={d.rcode}
                        isPaid={d.isPaid}
                        rid={d._id}
                        winnings={d.winnings}
                        activeModalId={activeModalId}
                      />
                    </div>
                  ))
                ) : (
                  <div style={{ textAlign: "center" }}>
                    No Public Contests Found
                  </div>
                )}
              </div>
            </>
          ) : (
            <></>
          )}
        </div>

        <div className="Tradathon__listings__live">
          {listingTab === "live" ? (
            tradathonLoading ? (
              [...Array(10).keys()].map((c, index) => (
                <div style={{ marginBottom: "10px" }} key={index}>
                  <DummyLiveCard key={index} />
                </div>
              ))
            ) : contests && contests.data?.length > 0 ? (
              contests.data.map((d, index) => (
                <div
                  onClick={() => {
                    if (!tradathonLoading) {
                      history.push(
                        `/tradathon/addcoins?rmid=${d._id}&rid=${d.rid}`
                      );
                      setActiveRoom(d);
                    }
                  }}
                  style={{ marginBottom: "10px" }}
                  key={d.rid}
                >
                  <LiveCard
                    key={d.rid}
                    noOfPlayers={d.room.noOfPlayers}
                    startTime={d.room.startTime}
                    endTime={d.room.endTime}
                    entryFees={d.room.entryFees}
                    prize={d.room.prize}
                    rtype={d.room.rtype}
                    joinedMembers={d.room.joinedMembers}
                    rname={d.room.rname}
                    isFlexible={d.room.isFlexible}
                    rstatus={d.room.rstatus}
                    rcode={d.room.rcode}
                    isPaid={d.isPaid}
                  />
                </div>
              ))
            ) : (
              <div style={{ textAlign: "center" }}>
                No Contests Found,{" "}
                <span
                  style={{
                    color: "#8d0792",
                    textDecoration: "underline",
                    cursor: "pointer",
                  }}
                  onClick={() => {
                    history.push("/tradathon/room");
                  }}
                >
                  Click to create a Contest here
                </span>{" "}
              </div>
            )
          ) : (
            <></>
          )}
        </div>
        <div className="Tradathon__listings__completed">
          {listingTab === "past" ? (
            tradathonLoading ? (
              [...Array(10).keys()].map((c, index) => (
                <div style={{ marginBottom: "10px" }} key={index}>
                  <DummyLiveCard key={index} />
                </div>
              ))
            ) : contests && contests.data?.length > 0 ? (
              contests.data.map((d, index) => (
                <div
                  onClick={() => {
                    history.push(
                      `/tradathon/addcoins?rmid=${d._id}&rid=${d.rid}`
                    );
                    setActiveRoom(d);
                  }}
                  style={{ marginBottom: "10px" }}
                  key={d.rid}
                >
                  <CompletedCard
                    key={d.rid}
                    noOfPlayers={d.room.noOfPlayers}
                    startTime={d.room.startTime}
                    entryFees={d.room.entryFees}
                    prize={d.room.prize}
                    rtype={d.room.rtype}
                    joinedMembers={d.room.joinedMembers}
                    rname={d.room.rname}
                    rank={d.rank}
                    isPaid={d.isPaid}
                    winAmt={d.winAmt?d.winAmt:null}
                  />
                </div>
              ))
            ) : (
              <div style={{ textAlign: "center" }}>
                No Contests Found,{" "}
                <span
                  style={{
                    color: "#8d0792",
                    textDecoration: "underline",
                    cursor: "pointer",
                  }}
                  onClick={() => {
                    history.push("/tradathon/room");
                  }}
                >
                  Click to create a Contest here
                </span>{" "}
              </div>
            )
          ) : (
            <></>
          )}
        </div>
      </div>
    </div>
  );
};

export default Tradathon;
